import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import "./App.css";
import { useAuth } from "./context/AuthContext";
import client, { setAuthRefreshing } from "./api/client";
import ProtectedRoute from "./components/ProtectedRoute";
import EntryListPage from "./pages/EntryListPage";
import NewEntryPage from "./pages/NewEntryPage";
import SessionDetailPage from "./pages/SessionDetailPage";
import EntryDetailPage from "./pages/EntryDetailPage";
import EditEntryPage from "./pages/EditEntryPage";
import RegisterPage from "./pages/RegisterPage";
import LoginPage from "./pages/LoginPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import InsightsPage from "./pages/InsightsPage";
import FilteredEntriesPage from "./pages/FilteredEntriesPage";
import WelcomePage from "./pages/WelcomePage";
import CheckEmailPage from "./pages/CheckEmailPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import ResendVerificationPage from "./pages/ResendVerificationPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import HomePage from "./pages/HomePage";
import AccountPage from "./pages/AccountPage";
import SitterPage from "./pages/SitterPage";
import GuidedSessionPage from "./pages/GuidedSessionPage";
import AgeGateModal from './components/AgeGateModal';

import SharedPage from "./pages/SharedPage";
import SharedAccessPage from "./pages/SharedAccessPage";
import CreateSharedConversation from "./pages/CreateSharedConversation";
import ConversationListPage from "./pages/ConversationListPage";
import PersonalPage from "./pages/PersonalPage";



async function initAuth() {
  setAuthRefreshing(true);

  try {
    await client.get("/me"); // triggers remember-me restore if needed
  } catch (e) {
    // ignore — user might not be logged in
  }

  setAuthRefreshing(false);
}

initAuth();


function AppLayout() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  
  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <>
    <AgeGateModal />
      <svg width="0" height="0" style={{ position: "absolute" }}>
        <filter id="swirlSmoke">
          <feTurbulence type="fractalNoise" baseFrequency="0.02" numOctaves="3" seed="5">
            <animate attributeName="baseFrequency"
              values="0.02;0.025;0.02"
              dur="10s"
              repeatCount="indefinite" />
          </feTurbulence>
          <feDisplacementMap in="SourceGraphic" scale="60" />
          <feGaussianBlur stdDeviation="5" />
        </filter>
      </svg>

      <div className="App" style={{ padding: 0, position: "relative", zIndex: 1 }}>
        {/* HEADER */}
        <div style={{
          background: "rgba(8, 16, 32, 0.6)",
          padding: "24px 32px",
          borderRadius: "12px 12px 0 0",
          boxShadow: "0 3px 10px rgba(0, 0, 0, 0.4)",
          borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}>
          <h1
            style={{
              margin: 0,
              fontWeight: "400",
              letterSpacing: "1px",
              fontFamily: "'Comfortaa', cursive",
              cursor: "pointer"
            }}
            onClick={() => navigate("/")}
          >
            Journey Trails
          </h1>

          <nav style={{ display: "flex", gap: "16px", alignItems: "center" }}>
  {user ? (
    <>
      <span style={{ fontSize: "13px", opacity: 0.6 }}>{user.email}</span>
      <span className="dot-sep" style={{ color: "#ffaa33", fontSize: "10px" }}>●</span>
      <span onClick={() => navigate("/insights")}
        style={{ fontSize: "14px", opacity: 0.9, cursor: "pointer", color: "#ffaa33" }}>
        Insights
      </span>
      <span className="dot-sep" style={{ color: "#ffaa33", fontSize: "10px" }}>●</span>
      <span onClick={() => navigate("/faq")}
        style={{ fontSize: "14px", opacity: 0.9, cursor: "pointer", color: "#ffaa33" }}>
        FAQ
      </span>
      <span className="dot-sep" style={{ color: "#ffaa33", fontSize: "10px" }}>●</span>
      <span onClick={() => navigate("/contact")}
        style={{ fontSize: "14px", opacity: 0.9, cursor: "pointer", color: "#ffaa33" }}>
        Contact
      </span>
      <span className="dot-sep" style={{ color: "#ffaa33", fontSize: "10px" }}>●</span>
      <span onClick={() => navigate("/account")}
        style={{ fontSize: "14px", opacity: 0.9, cursor: "pointer", color: "#ffaa33" }}>
          Account
      </span>
      <span className="dot-sep" style={{ color: "#ffaa33", fontSize: "10px" }}>●</span>
      <span onClick={handleLogout}
        style={{ fontSize: "14px", opacity: 0.9, cursor: "pointer", color: "#ffaa33" }}>
        Log Out
      </span>
    </>
  ) : (
    <>
      <span onClick={() => navigate("/faq")}
        style={{ fontSize: "14px", opacity: 0.9, cursor: "pointer", color: "#ffaa33" }}>
        FAQ
      </span>
      <span className="dot-sep" style={{ color: "#ffaa33", fontSize: "10px" }}>●</span>
      <span onClick={() => navigate("/contact")}
        style={{ fontSize: "14px", opacity: 0.9, cursor: "pointer", color: "#ffaa33" }}>
        Contact
      </span>
      <span className="dot-sep" style={{ color: "#ffaa33", fontSize: "10px" }}>●</span>
      <span onClick={() => navigate("/login")}
        style={{ fontSize: "14px", opacity: 0.9, cursor: "pointer", color: "#ffaa33" }}>
        Log In
      </span>
      <span className="dot-sep" style={{ color: "#ffaa33", fontSize: "10px" }}>●</span>
      <span onClick={() => navigate("/register")}
        style={{ fontSize: "14px", opacity: 0.9, cursor: "pointer", color: "#ffaa33" }}>
        Register
      </span>
    </>
  )}
</nav>
        </div>

        {/* CONTENT */}
        <div style={{ padding: "24px" }}>
          <Routes>
            <Route path="/" element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            } />

            <Route path="/new" element={
             <ProtectedRoute>
              <>
               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px" }}>
                <h2 style={{ marginTop: 0, marginBottom: 0 }}>New Entry</h2>
                <span
                 onClick={() => navigate("/")}
                 style={{
                  cursor: "pointer",
                  fontSize: "14px",
                  opacity: 0.9,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px"
                }}
               >
                ← Back
              </span>
            </div>
            <NewEntryPage onSaved={() => navigate("/")} />
           </>
          </ProtectedRoute>
           } />
            <Route path="/entry/:id" element={
              <ProtectedRoute>
                <>
                  <div style={{ marginBottom: "16px" }}>
                    <span
                      onClick={() => navigate(-1)}
                      style={{
                      cursor: "pointer",
                      fontSize: "14px",
                      opacity: 0.7,
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "4px"
                    }}
                  >
                    ← Back
                  </span>
                </div>
              <EntryDetailPage />
            </>
            </ProtectedRoute>
            } />
            <Route path="/entries/filtered" element={
             <ProtectedRoute>
              <>
               <span
                onClick={() => navigate("/insights")}
                style={{
                 cursor: "pointer",
                 fontSize: "14px",
                 opacity: 0.7,
                 display: "inline-flex",
                 alignItems: "center",
                 gap: "4px"
               }}
              >
             ← Back to Insights
              </span>
             <FilteredEntriesPage />
            </>
           </ProtectedRoute>
           } />
           <Route path="/entries" element={
            <ProtectedRoute>
              <>
               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                 <h2 style={{ margin: 0 }}>My Journey</h2>
                 <button onClick={() => navigate("/new")}>New Entry</button>
               </div>
               <EntryListPage onSelect={(id) => navigate(`/entry/${id}`)} />
             </>
            </ProtectedRoute>
           } />
            <Route path="/entry/:id/edit" element={
              <ProtectedRoute>
                <>
                  <div style={{ marginBottom: "16px" }}>
                    <span
                      onClick={() => navigate(-1)}
                      style={{
                        cursor: "pointer",
                        fontSize: "14px",
                        opacity: 0.7,
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "4px"
                      }}
                    >
                      ← Back
                    </span>
                  </div>
                  <EditEntryPage />
                </>
              </ProtectedRoute>
            } />
            <Route path="/guided-session" element={
              <ProtectedRoute>
                <GuidedSessionPage />
              </ProtectedRoute>
            } />
            <Route path="/session/:id" element={
              <ProtectedRoute>
                <>
                  <div style={{ marginBottom: "16px" }}>
                    <span
                      onClick={() => navigate(-1)}
                      style={{
                      cursor: "pointer",
                      fontSize: "14px",
                      opacity: 0.7,
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "4px"
                    }}
                  >
                    ← Back
                  </span>
                </div>
              <SessionDetailPage />
              </>
            </ProtectedRoute>
            } />
            <Route
              path="/shared/create"
              element={
                <ProtectedRoute>
                  <CreateSharedConversation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/conversations"
              element={
                <ProtectedRoute>
                  <ConversationListPage />
                </ProtectedRoute>
              }
            />

<Route
  path="/personal/:conversationId"
  element={
    <ProtectedRoute>
      <PersonalPage />
    </ProtectedRoute>
  }
/>


            <Route path="/insights" element={
              <ProtectedRoute>
                <InsightsPage />
              </ProtectedRoute>
            } />
            <Route path="/account" element={
              <ProtectedRoute>
                <AccountPage />
              </ProtectedRoute>
            } />
            <Route path="/check-email" element={<CheckEmailPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/resend-verification" element={<ResendVerificationPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/welcome" element={<WelcomePage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/sitter/:token" element={<SitterPage />} />
            <Route path="/shared/:token" element={<SharedPage />} />
            <Route path="/shared/:token/access" element={<SharedAccessPage />} />
          </Routes>
        </div>

        {/* FOOTER */}
         <div style={{
          background: "rgba(8, 16, 32, 0.6)",
          padding: "46px 32px",
          borderRadius: "0 0 12px 12px",
          boxShadow: "0 -3px 10px rgba(0, 0, 0, 0.4)",
          borderTop: "1px solid rgba(255, 255, 255, 0.1)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "40px"
        }}>
         <span className="footer-left" style={{ fontSize: "13px", opacity: 0.8 }}>
           © {new Date().getFullYear()}  Journey Trails <br className="mobile-break" /> <span className="footer-dash">—</span> <i>mindful journey mapping</i>
        </span>
        <span className="footer-right" style={{ fontSize: "13px" }}>
          <span style={{ opacity: 0.8, fontStyle: "italic" }}>
            Supported by you amazing users!
          </span>
         <a
          href="https://buymeacoffee.com/journeytrails"
          target="_blank"
          rel="noreferrer"
          style={{ marginLeft: "2px", color: "#ffaa33", textDecoration: "none", fontSize: "13px", opacity: 0.9 }}
         > 
          ☕ Buy me a coffee
        </a>
       </span>
       </div>    
      </div>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}